import { GET_CUSTOM_TAGS, ADD_CUSTOM_TAGS, UPDATE_CUSTOM_TAGS, TAG_BUTTON_CLICKED, TAG_BUTTON_CLICKED_RESET } from "../types"

const initialState = {
	custom_tags: {
		tags: [],
	},
	tagButtonClicked: false,
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case UPDATE_CUSTOM_TAGS:
			console.log(action.payload)
			let auxTagsUpdate = state.custom_tags.tags
			var index = -1
			var filteredObj = auxTagsUpdate.find(function (item, i) {
				if (item.tag_id === action.payload.id) {
					index = i
					return i
				}
			})
			if (index > -1) {
				auxTagsUpdate[index] = {
					color_id: action.payload.color_id,
					name: action.payload.name,
					tag_id: action.payload.id,
				}
			}
			console.log(auxTagsUpdate)
			return {
				...state,
				custom_tags: { tags: auxTagsUpdate },
			}
		case ADD_CUSTOM_TAGS:
			let auxTags = state.custom_tags.tags
			auxTags.push({
				color_id: action.payload.color_id,
				name: action.payload.name,
				tag_id: action.payload.id,
			})
			return {
				...state,
				custom_tags: { tags: auxTags },
			}
		case GET_CUSTOM_TAGS:
			return {
				...state,
				custom_tags: { tags: action.payload },
			}
		case TAG_BUTTON_CLICKED: {
			return {
				...state,
				tagButtonClicked: true,
			}
		}
		case TAG_BUTTON_CLICKED_RESET: {
			return {
				...state,
				tagButtonClicked: false,
			}
		}
		default:
			return state
	}
}
